import { QRCodeCanvas } from 'qrcode.react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { useToast } from '../../../components/Toast';
import { Dropdown } from 'primereact/dropdown';
import BreadcrumbComponent from '../../../components/Breadcrumb';
import "jspdf-autotable";
import { TieredMenu } from "primereact/tieredmenu";
import { exportExcel, exportQrPDF } from "../../../components/Export";
import { Sidebar } from 'primereact/sidebar';
import { Fieldset } from 'primereact/fieldset';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import assignmentService from './assignment-service';
import { LayoutContext } from '../../../layout/context/LayoutContext';
import { LayoutConfig } from '../../../types/types';
import Layout from '../../../layout/layout';
import { useDialog } from '../../../components/Dialog';
import { ASTexceptions } from '../ASTexceptions';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    'fullName': {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    representative: { value: null, matchMode: FilterMatchMode.IN },
    date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
};

interface RecordFilter {
    [key: string]: string | boolean | Date; // Adjust types as needed
}

const AssignmentView: React.FC = () => {
    const navigate = useNavigate();
    const [clientState, setClientState] = useState<any>(null);
    const [isValid, setIsValid] = useState<boolean>(true);
    const { showToast } = useToast();
    const menuRef = useRef<TieredMenu>(null);
    const [qrData, setQrData] = useState<any>(null);
    const [displayConfirmation, setDisplayConfirmation] = useState(false);

    const [recordFilter, setRecordFilter] = useState<RecordFilter>({
        dateFrom: new Date(),
        dateTo: new Date(),
    });
    const { showExceptionDialog, showConfirmDialog } = useDialog();
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const { param } = useParams();

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await assignmentService.getClientState();
                setClientState(clientStateItem);
            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    useEffect(() => {
        // if (clientState) {
        const fetchUserList = async () => {

            try {
                assignmentService.findOneQRNoAccess(param).then((data) => {
                    if (data) {
                        if (data.instrumentId) {
                            setQrData(data);
                            assignmentService.findOneInstrumentNoAccess(data.instrumentId).then((data) => {
                                if (data) {
                                    setSelectedItem(data);
                                } else {
                                    showExceptionDialog(103, ASTexceptions);
                                }
                            });
                        } else {
                            setDisplayConfirmation(true);
                        }
                    } else {
                        showExceptionDialog(101, ASTexceptions);
                        navigate(`/login`);
                    }
                });
            } catch (error) {
            }
        };

        fetchUserList();
        // }
    }, [clientState, recordFilter]);

    const renderQRCode = (rowData: any) => {
        return (
            <div className="flex justify-center p-4">
                <QRCodeCanvas value={rowData?.qrValue} size={180} />
            </div>
        );
    };

    function confirmAssign(): void {
        setDisplayConfirmation(false);
        navigate(`/asset/assignment/login/${param}`);
    };

    function cancelAssign(): void {
        setDisplayConfirmation(false);
    };




    return (
        <div className='full-screen-container'>
            <div className="col-12">
                <Dialog
                    header="Confirmation"
                    visible={displayConfirmation}
                    onHide={() => setDisplayConfirmation(false)}
                    style={{ width: '350px' }}
                    modal
                >
                    No instrument has been assigned to this QR.
                    To continue, please proceed to the login page to complete the instrument assignment.
                    <div>
                        <br />
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: '1rem' }}>
                        <Button outlined type="button" className="p-button-success" onClick={confirmAssign}>
                            Proceed to Login
                        </Button>

                        <Button outlined type="button" className="p-button-danger" onClick={cancelAssign}>
                            Cancel
                        </Button>
                    </div>

                </Dialog>
                <br></br>
                <div className="card">
                    <div className="field col-12 flex justify-content-center">
                        {qrData?.qrValue ? renderQRCode(qrData) : null}
                    </div>
                    <div className="p-fluid form-grid-edit grid">
                        <div className="f-view">
                            <label className="f-label">Serial No</label>
                            <div className="f-input">{selectedItem?.snNo || 'N/A'}</div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Instrument Code</label>
                            <div className="f-input">{selectedItem?.itemCode || 'N/A'}</div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Instrument Name</label>
                            <div className="f-input">{selectedItem?.itemDesc || 'N/A'}</div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Installation Location</label>
                            <div className="f-input">{selectedItem?.installationLocation || 'N/A'}</div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Manufacturer Name</label>
                            <div className="f-input">{selectedItem?.manufacturerName || 'N/A'}</div>
                        </div>

                        {selectedItem?.entity !== 'BMSG' && (
                            <div className="f-view">
                                <label className="f-label">Region</label>
                                <div className="f-input">{selectedItem?.regionHasOne?.fullDesc || 'N/A'}</div>
                            </div>
                        )}

                        <div className="f-view">
                            <label className="f-label">Equipment Type</label>
                            <div className="f-input">{selectedItem?.equipType?.toUpperCase() || 'N/A'}</div>
                        </div>

                        {/* <div className="field col-12 md:col-4">
                            <label>Entity</label>
                            <div className="view-form">{selectedItem?.entity || ''}</div>
                        </div> */}
                        <div className="f-view">
                            <label className="f-label">Last PM Date</label>
                            <div className="f-input">
                                {selectedItem?.lastPmDate
                                    ? new Date(selectedItem.lastPmDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                    })
                                    : 'N/A'}
                            </div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Next PM Date</label>
                            <div className="f-input">
                                {selectedItem?.nextPmDate
                                    ? new Date(selectedItem.nextPmDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                    })
                                    : 'N/A'}
                            </div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Installation Date</label>
                            <div className="f-input">
                                {selectedItem?.installDate
                                    ? new Date(selectedItem.installDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                    })
                                    : 'N/A'}
                            </div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Warranty End Date</label>
                            <div className="f-input">
                                {selectedItem?.warrantyEndDate
                                    ? new Date(selectedItem.warrantyEndDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                    })
                                    : 'N/A'}
                            </div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Item Status</label>
                            <div className="f-input">{selectedItem?.status || 'N/A'}</div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Contract Start Date</label>
                            <div className="f-input">
                                {selectedItem?.contractStartDate
                                    ? new Date(selectedItem.contractStartDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                    })
                                    : 'N/A'}
                            </div>
                        </div>

                        <div className="f-view">
                            <label className="f-label">Contract End Date</label>
                            <div className="f-input">
                                {selectedItem?.contractEndDate
                                    ? new Date(selectedItem.contractEndDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                    })
                                    : 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div>
                        <br />
                    </div>
                    {/* <Card className="bg-gradient-to-br from-blue-200 to-blue-100 shadow-lg rounded-2xl p-6 mt-4 border border-blue-200"> */}
                    <Card className="bg-gradient-to-br from-blue-400 via-blue-200 to-blue-300 rounded-2xl border border-blue-300"
                        style={{ boxShadow: '0 8px 40px 0 rgba(30, 64, 175, 0.28)' }}>
                        {selectedItem?.entity?.toLowerCase() === "bms" && (
                            <div className="field col-12 flex justify-content-center">
                                <div className="text-center text-blue-900 w-full">
                                    <div className="text-xl font-bold mb-2">📞 Biomed Global Sdn Bhd.</div>
                                    <div className="mb-1">🏢 Biomed Global Sdn Bhd</div>
                                    <div className="mb-1">
                                        <span className="font-medium">☎️ Tel:</span> +(60)3-62870066
                                    </div>
                                    <div>
                                        <span className="font-medium">💡 Technical Service Hotline:</span> +(60) 12 684 2336
                                        {/* <a href="tel:019234334444" className="text-blue-700 underline ml-1">019-234334444</a> */}
                                    </div>
                                    <div className="mb-1">
                                        <span className="font-medium">📧 Email:</span>
                                        <a href="mailto:techservice.my@biomedglobal.com" className="text-blue-700 underline ml-1">
                                            techservice.my@biomedglobal.com
                                        </a>
                                    </div>
                                    <div>
                                        <span className="font-medium">🌐 Website:</span>
                                        <a href="https://biomedglobal.com/" target="_blank" rel="noopener noreferrer" className="text-blue-700 underline ml-1">
                                            biomedglobal.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedItem?.entity?.toLowerCase() === "bmsd" && (
                            <div className="field col-12 flex justify-content-center">
                                <div className="text-center text-blue-900 w-full">
                                    <div className="text-xl font-bold mb-2">📞 Biomed Global Sdn Bhd.</div>
                                    <div className="mb-1">🏢 Biomed Global Sdn Bhd</div>
                                    <div className="mb-1">
                                        <span className="font-medium">☎️ Tel:</span> +(60)3-6287006
                                    </div>
                                    <div>
                                        <span className="font-medium">💡 Technical Service Hotline:</span> +(60) 12 227 6287
                                    </div>
                                    <div className="mb-1">
                                        <span className="font-medium">📧 Email:</span>
                                        <a href="mailto:techservice.my@biomedglobal.com" className="text-blue-700 underline ml-1">
                                            techservice.my@biomedglobal.com
                                        </a>
                                    </div>
                                    <div>
                                        <span className="font-medium">🌐 Website:</span>
                                        <a href="https://biomedglobal.com/" target="_blank" rel="noopener noreferrer" className="text-blue-700 underline ml-1">
                                            biomedglobal.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedItem?.entity?.toLowerCase() === "bmsg" && (
                            <div className="field col-12 flex justify-content-center">
                                <div className="text-center text-blue-900 w-full">
                                    <div className="text-xl font-bold mb-2">📞 Biomed Global (Singapore)</div>
                                    <div className="mb-1">🏢 Biomed Diagnostics Ptd Ltd</div>
                                    <div className="mb-1">
                                        <span className="font-medium">☎️ Tel:</span>+(65)62984347
                                    </div>
                                    <div>
                                        <span className="font-medium">💡 Technical Service Hotline:</span>
                                    </div>
                                    <div className="mb-1">
                                        <span className="font-medium">📧 Email:</span>
                                        <a href="mailto:techservice.sg@biomedglobal.com" className="text-blue-700 underline ml-1">
                                            techservice.sg@biomedglobal.com
                                        </a>
                                    </div>
                                    <div>
                                        <span className="font-medium">🌐 Website:</span>
                                        <a href="https://biomedglobal.com/" target="_blank" rel="noopener noreferrer" className="text-blue-700 underline ml-1">
                                            biomedglobal.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedItem?.entity?.toLowerCase() === "ptbgs" && (
                            <div className="field col-12 flex justify-content-center">
                                <div className="text-center text-blue-900 w-full">
                                    <div className="text-xl font-bold mb-2">📞 Biomed Sinergi</div>
                                    <div className="mb-1">🏢 PT Biomed Global Sinergi</div>
                                    <div className="mb-1">
                                        <span className="font-medium">☎️ Tel:</span>+(62) 821 1212 7671
                                    </div>
                                    <div>
                                        <span className="font-medium">💡 Technical Service Hotline:</span>+(62) 821 1212 7671
                                    </div>
                                    <div className="mb-1">
                                        <span className="font-medium">📧 Email:</span>
                                        <a href="mailto:techservice.id@biomedglobal.com" className="text-blue-700 underline ml-1">
                                            techservice.id@biomedglobal.com
                                        </a>
                                    </div>
                                    <div>
                                        <span className="font-medium">🌐 Website:</span>
                                        <a href="https://biomedglobal.com/" target="_blank" rel="noopener noreferrer" className="text-blue-700 underline ml-1">
                                            biomedglobal.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}

                    </Card>
                </div>
            </div>
        </div>
    );
};

export default AssignmentView;

